import React, { useEffect, useContext } from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";

import { bindActionCreators, Dispatch } from "redux";

import { Dialog as DialogComponent, OkButton, Overlay, ActionBar, Sticky } from "@plex/react-components";

import { Banner } from "ui/app";
import { DialogContainer, DialogContext, ActionBarLink } from "ui/app/navigation";
import { useLocalizedValues } from "ui/hooks";
import { glossaryMessages } from "ui/screens/plex-dictionary/plex-dictionary.localization";

import { TermTranslationsGrid } from "./grid";
import { termTranslationsActions } from "./TermTranslations.actions";
import { ITermTranslationsState } from "./TermTranslations.state";

interface ITermTranslationsProps {
  state: ITermTranslationsState;
  loadTermTranslations: (params: { termId: string; status: string }) => void;
  clearState: () => void;
}

export const TermTranslations: React.FC<ITermTranslationsProps & RouteComponentProps> = ({ state, match, loadTermTranslations, clearState }) => {
  const localizedValues = useLocalizedValues(() => ({
    historyText: glossaryMessages.property("history")
  }));

  const termId = match.params["termId"];
  const termTranslationStatus = match.params["status"];

  const dialogContext = useContext(DialogContext);

  useEffect(() => {
    loadTermTranslations({
      termId: termId,
      status: termTranslationStatus
    });
  }, [loadTermTranslations, termId, termTranslationStatus]);

  const mainContent = (
    <>
      <Overlay show={state.isLoading} showSpinner />
      <Sticky>
        <ActionBar>
          <ActionBarLink
            openInDialog={dialogContext.isOpened}
            title={localizedValues.historyText}
            text={localizedValues.historyText}
            href={`/terms/${termId}/translation-history`}
          />
        </ActionBar>
      </Sticky>
      <Banner messages={state.notifications} />
      <TermTranslationsGrid translations={state.translations} />
    </>
  );

  return (
    <>
      <DialogContainer
        onHidden={clearState}
        render={dialogProps => {
          return (
            <DialogComponent {...dialogProps}>
              <DialogComponent.Body>{mainContent}</DialogComponent.Body>
              <DialogComponent.Footer>
                <OkButton onClick={dialogProps.onHide} />
              </DialogComponent.Footer>
            </DialogComponent>
          );
        }}
      />
      {!dialogContext.isOpened && mainContent}
    </>
  );
};

export default connect(
  (state: { termTranslations: ITermTranslationsState }) => {
    return {
      state: state.termTranslations
    };
  },
  (dispatch: Dispatch) => bindActionCreators({ loadTermTranslations: termTranslationsActions.loadTermTranslations, clearState: termTranslationsActions.clearState }, dispatch)
)(TermTranslations);
